// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__J_q0Q","title":"styles_title__4f_aA"};